<template>
	<div id="app">
		<nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
			<div class="navbar-brand">
				<a class="navbar-item" href="/dashboard">
					<img src="@/assets/logo.svg" width="240">
				</a>

				<a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" v-if="$store.state.isInAppBase" data-target="navbarBasicExample" @click="isBurgerOpen = !isBurgerOpen" :class="{ 'is-active': isBurgerOpen }">
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
				</a>
			</div>

			<div id="navbarBasicExample" class="navbar-menu" :class="{ 'is-active': isBurgerOpen }" v-if="$store.state.isInAppBase">
				<div class="navbar-start">
					<a class="navbar-item" @click="$router.push({ name: 'dashboard' })"><i class="far fa-calendar-alt"></i>&nbsp;カレンダー</a>
					<a class="navbar-item" @click="$router.push({ name: 'time-card' })"><i class="far fa-clock"></i>&nbsp;タイムカード</a>
					<a class="navbar-item" @click="onLogoutClick"><i class="fas fa-sign-out-alt"></i>&nbsp;ログアウト</a>

					<!--
					<div class="navbar-item has-dropdown is-hoverable">
						<a class="navbar-link">
							More
						</a>

						<div class="navbar-dropdown">
							<a class="navbar-item">
								About
							</a>
							<a class="navbar-item">
								Jobs
							</a>
							<a class="navbar-item">
								Contact
							</a>
							<hr class="navbar-divider">
							<a class="navbar-item">
								Report an issue
							</a>
						</div>
					</div>
					-->
				</div>

				<!--
				<div class="navbar-end">
					<div class="navbar-item">
						<div class="buttons">
							<a class="button is-primary">
								<strong>Sign up</strong>
							</a>
							<a class="button is-light">
								Log in
							</a>
						</div>
					</div>
				</div>
				-->
			</div>
		</nav>

		<div class="main-container">
			<router-view/>
		</div>

		<div class="footer-area is-fixed-bottom">
		</div>
	</div>
</template>

<script>
export default {
	name: 'app',
	data: function() {
		return {
			isBurgerOpen: false,
		}
	},
	mounted() {
	},
	watch: {
		'$route': function (to, from) {
			if (to.path !== from.path) {
				this.isBurgerOpen = false;
			}
		},
	},
	methods: {
		onLogoutClick: function() {
			this.$auth.logout();
			this.$router.push({ name: 'login' });
		},
	},
}
</script>

<style lang="scss">
html, body {
	background: #f3f6f7;
	color: #4d4d4d;
}
.btn {
	padding: 10px 0;
	background : linear-gradient(-45deg, rgba(0, 113, 188, 1) 2.8%, rgba(169, 221, 243, 1) 100%);
	border-radius: 10px;
	color: #fff;
	font-size: 16px;
	font-weight: bold;
	-webkit-box-sizing: content-box;
	-webkit-appearance: button;
	appearance: button;
	border: none;
	box-sizing: border-box;
	cursor: pointer;
	display: block;
}

.overlay {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 999;
	width: 100%;
	height: 100%;
	background: rgba(255, 255, 255, .5);
	opacity: 0;
	visibility: hidden;
	transition: .2s linear;
}
.overlay.is-open {
	opacity: 1;
	visibility: visible;
}
.loader.is-open {
	opacity: 1;
	visibility: visible;
	display: block;
}
.loader,
.loader:after {
	border-radius: 50%;
	width: 10em;
	height: 10em;
}
.loader {
	position: fixed;
	top:calc(50% - 10em/2);
	left:calc(50% - 10em/2);
	z-index: 9999;
	font-size: 10px;
	text-indent: -9999em;
	border-top: 1.1em solid rgba(189,189,189, 0.2);
	border-right: 1.1em solid rgba(189,189,189, 0.2);
	border-bottom: 1.1em solid rgba(189,189,189, 0.2);
	border-left: 1.1em solid #bdbdbd;
	-webkit-transform: translateZ(0);
	-ms-transform: translateZ(0);
	transform: translateZ(0);
	-webkit-animation: load8 1.1s infinite linear;
	animation: load8 1.1s infinite linear;
	visibility: hidden;
	transition: .2s linear;
}
@-webkit-keyframes load8 {
	0% {
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	100% {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
@keyframes load8 {
	0% {
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	100% {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}

.fc-view-container {
	background: #fff;
}

.fc-sat {
	color: blue;
}

.fc-sun {
	color: red;
}

.fc-event {
	border: none !important;
	background-color: transparent !important;
}

.fc-smile {
	width: 30px;
	height: auto;
}

.fc-event-container {
	text-align: center;
}



$spaces: (0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80); // 0から50pxまでを用意
$sides: (top, bottom, left, right); // 方向性
@each $space in $spaces {
	@each $side in $sides {
		.m#{str-slice($side, 0, 1)}-#{$space} {
			margin-#{$side}: #{$space}px !important;
		}

		.p-#{str-slice($side, 0, 1)}-#{$space} {
			padding-#{$side}: #{$space}px !important;
		}
	}
}

.navbar {
	background : linear-gradient(-90deg, rgba(0, 113, 188, 1) 2.8%, rgba(168, 228, 246, 1) 90.73%, rgba(169, 221, 243, 1) 100%);
}

.footer-area {
	background : linear-gradient(90deg, rgba(0, 113, 188, 1) 2.8%, rgba(168, 228, 246, 1) 90.73%, rgba(169, 221, 243, 1) 100%);
		width: 100%;
		height: 20px;
		position: fixed;
		bottom: 0;
}

.main-container {
	padding: 80px 10px 40px;
}

.work-registration {
	.button {
		-webkit-appearance: none;
		border: none;
		width: 110px;
		height: 110px;
		background: none;
	}

	.date {
		color: #0071BC;
		font-size: 28px;
		margin-bottom: 20px;
	}

	.greeting {
		width: 280px;
		margin: 0 auto;
	}
}

.work-registration-complete {
	width: 280px;
	margin: 0 auto;

	.move-btn {
		width: 200px;
		margin: 0 auto;
	}
}

$bbMainColor: #0071bc;
//$bbBgColor: #cbe8fc;
$bbBgColor: #fff;

blockquote {
		position: relative;
		padding: 10px 15px 10px 30px;
		box-sizing: border-box;
		font-style: italic;
		font-weight: bold;
		color: #464646;
		background: $bbBgColor;
		border: solid 2px $bbMainColor;
	border-radius: 3px;
}

blockquote:before{
		display: inline-block;
		position: absolute;
		top: 12px;
		left: 3px;
		content: "“";
		font-family: sans-serif;
		color: $bbMainColor;
		font-size: 35px;
		line-height: 1;
}

blockquote p {
		padding: 0;
		margin: 10px 0;
		line-height: 1.7;
	white-space: pre-wrap;
	word-wrap:break-word;
}

blockquote cite {
		display: block;
		text-align: right;
		color: #888888;
		font-size: 13px;
}

.navbar-burger {
	span {
		color: #fff;
		height: 2px;
	}
}

</style>
